import { FileText } from 'lucide-react'

interface StatusBarProps {
    currentLine?: number
    currentColumn?: number
    totalLines?: number
    fileSize?: number
    fileName?: string
    encoding?: string
    lineEnding?: 'LF' | 'CRLF'
    language?: string
}

export function StatusBar({
    currentLine = 1,
    currentColumn = 1,
    totalLines = 0,
    fileSize = 0,
    fileName = '',
    encoding = 'UTF-8',
    lineEnding = 'LF',
    language = 'Markdown'
}: StatusBarProps) {
    // Format file size
    const formatFileSize = (bytes: number): string => {
        if (bytes === 0) return '0 Bytes'
        const k = 1024
        const sizes = ['Bytes', 'KB', 'MB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    }

    return (
        <div className="flex items-center justify-between px-4 py-1.5 text-xs bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-400">
            {/* Left side - File info */}
            <div className="flex items-center gap-4">
                {fileName && (
                    <div className="flex items-center gap-1.5">
                        <FileText size={14} />
                        <span className="font-medium">{fileName}</span>
                    </div>
                )}
                {fileSize > 0 && (
                    <span>{formatFileSize(fileSize)}</span>
                )}
                {totalLines > 0 && (
                    <span>{totalLines} lines</span>
                )}
            </div>

            {/* Right side - Editor info */}
            <div className="flex items-center gap-4">
                <button
                    className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                    title="Line and column position"
                >
                    Ln {currentLine}, Col {currentColumn}
                </button>
                <button
                    className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                    title="File encoding"
                >
                    {encoding}
                </button>
                <button
                    className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                    title="Line ending type"
                >
                    {lineEnding}
                </button>
                <button
                    className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                    title="File language"
                >
                    {language}
                </button>
            </div>
        </div>
    )
}
